/**** FORM LOGIN ***/
let loginForm = $('#customer_login');
loginForm.submit(function () {
  dataLayer.push({        
    "event": "login",
  });
})


/**** FORM SIGNUP ***/
let signupForm = $('#create_customer');
signupForm.submit(function () {
  dataLayer.push({        
    "event": "signup",
  });
})


/**** FORM NEWSLETTER ***/
let newsletterForm = $('#sib-form');
newsletterForm.submit(function () {
  dataLayer.push({        
    "event": "newsletter",
  });
})


/**** MENU ***/
let navLinks = document.querySelectorAll("nav a, nav span[href], .menu-drawer__menu-item");
if (navLinks) {
    navLinks.forEach(link => {
        link.addEventListener('click', function () {
            dataLayer.push({        
              "event": "click_menu", 
              "categoria_menu": link.innerText,
            });
        })
    });
}


/*** PHONE ***/
let trackPhone = document.querySelectorAll('a[href^="tel:"]');
if (trackPhone) {
    trackPhone.forEach(phone => {
        phone.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_phone",
            });
        })
    });
}



/**** MAIL ***/
let trackEmail = document.querySelectorAll('a[href^="mailto:"]');
if (trackEmail) {
    trackEmail.forEach(email => {
        email.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_mail",
            });
        })
    });
}


/**** SOCIAL ****/
let socials = document.querySelectorAll(".list-social__link");
if (socials) {
    socials.forEach(social => {
        social.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_social",
                "nome_evento": social.dataset.social,
            });
        })
    });
}



/*** BLOG ***/
let trackBlogPosts = document.querySelectorAll(".track_post");
if (trackBlogPosts) {
    trackBlogPosts.forEach(blogPost => {
        blogPost.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_articolo_blog",
                "articolo_blog": blogPost.dataset.nome,
            });
        })
    });
}

